<script lang="ts">
    import { availableTemplates, loadPalette, palette } from "$lib/image/palette";

    const { active } = palette;


    function changePalette(e: Event) {
        const target = e.target as HTMLSelectElement;
        loadPalette(target.value);
    }
</script>

<!----------------------------------------------------------------------------->

<select value={$active.name} on:input={changePalette}>
    {#each $availableTemplates as palette}
        <option>{palette}</option>
    {/each}
</select>

<!----------------------------------------------------------------------------->

<style>
    select {
        flex-grow: 1;
        margin-left: 1em;
    }
</style>
